export interface IPrincipleData {
  title: string;
  description: string;
  color?: string;
  backgroundColor?: string;
}
export const PrincipleDatas = [
  {
    id: 1,
    title: "Integrity",
    backgroundColor: "#fdba74",
    color: "#431407",
    description:
      "We adopt the highest ethical standard of our industry and operate with transparency and trust Integrity. ",
  },
  {
    id: 2,
    title: "Compassion",
    backgroundColor: "#86efac",
    color: "#365314",
    description:
      "We love and care for everyone and tread them as equals. It has a very significant value on how we work. ",
  },
  {
    id: 3,
    title: "Realizaton",
    backgroundColor: "#7dd3fc",
    color: "#164e63",
    description:
      "We are guided by fact base reality. Hence, realization makes us aware and get experience from the failure.",
  },
  {
    id: 4,
    title: "Excelence",
    backgroundColor: "#f9a8d4",
    color: "#9f1239",
    description:
      "We always deliver what we promised. We shall never compromise to provide quality service to our client. Through our company commitment to excellence, we strive to meet our customer needs. ",
  },
  {
    id: 5,
    title: "Collaboration",
    backgroundColor: "#d4d4d4",
    color: "#18181b",
    description:
      "We believe in team work. We encourage our member to share their knowledge, skill & experience among other staffs.",
  },
];
